import React from 'react';
import './ServerErrorMessage.css';

export default (props) => (
  <div className="ServerErrorMessage" style={props.style}>
    {props.children}
  </div>
);
